import React, { useMemo } from 'react'
import { useFormState } from 'react-hook-form'
import { CreditApplicationBusinessEntity } from '_gql'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'
import { FormDropdown } from '@divvy-web/skylab.form'

const EntityTypeCombobox = ({
  control,
  readOnly,
}: Omit<React.ComponentProps<typeof FormDropdown>, 'name' | 'options'>) => {
  const { isLoading } = useFormState({ control })
  const { formatMessage } = useIntl()

  const entityTypeOptions = useMemo(
    () => [
      {
        value: CreditApplicationBusinessEntity.BANK_OR_CREDIT_UNION,
        label: formatMessage({
          defaultMessage: 'Bank/Bank holding co/credit union',
          id: 'sputnik.NameAndOwnershipForm__EPCZde',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.CORPORATIONS,
        label: formatMessage({
          defaultMessage: 'Corporations',
          id: 'sputnik.NameAndOwnershipForm__OvqNJo',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.GOVERNMENT_AGENCY,
        label: formatMessage({
          defaultMessage: 'Federal/State/Local government agency or authority',
          id: 'sputnik.NameAndOwnershipForm__JVcctq',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.INSURANCE_COMPANY,
        label: formatMessage({
          defaultMessage: 'Insurance company',
          id: 'sputnik.NameAndOwnershipForm__TfybEX',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.INVESTMENT_COMPANY,
        label: formatMessage({
          defaultMessage: 'Investment company/adviser',
          id: 'sputnik.NameAndOwnershipForm__VHwYiy',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.LIMITED_LIABILITY_COMPANY,
        label: formatMessage({
          defaultMessage: 'Limited liability companies',
          id: 'sputnik.NameAndOwnershipForm__S9eo6V',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.NON_PROFITS,
        label: formatMessage({
          defaultMessage: 'Non-Profits',
          id: 'sputnik.NameAndOwnershipForm__bYRuHA',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.NON_STATUTORY_TRUST,
        label: formatMessage({
          defaultMessage: 'Non-Statutory trust',
          id: 'sputnik.NameAndOwnershipForm__+VU5c2',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.PARTNERSHIP,
        label: formatMessage({
          defaultMessage: 'Partnerships',
          id: 'sputnik.NameAndOwnershipForm__Jhs7F+',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.PUBLIC_ACCOUNTING_FIRM,
        label: formatMessage({
          defaultMessage: 'Public accounting firm',
          id: 'sputnik.NameAndOwnershipForm__sVVJSK',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.PUBLIC_COMPANY,
        label: formatMessage({
          defaultMessage: 'Public company and majority owned affiliate',
          id: 'sputnik.NameAndOwnershipForm__PryonG',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.SOLE_PROPRIETORSHIP,
        label: formatMessage({
          defaultMessage: 'Sole proprietorship',
          id: 'sputnik.NameAndOwnershipForm__m+1Hgd',
        }),
        className: 'fs-unmask',
      },
      {
        value: CreditApplicationBusinessEntity.UNINCORPORATED_ASSOCIATION,
        label: formatMessage({
          defaultMessage: 'Unincorporated association',
          id: 'sputnik.NameAndOwnershipForm__GFw9E7',
        }),
        className: 'fs-unmask',
      },
    ],
    [formatMessage],
  )

  return (
    <FormDropdown
      isPortal
      isSearchable
      className='fs-unmask'
      control={control}
      disabled={isLoading}
      label={
        <span className='fs-unmask'>
          <FormattedMessage
            defaultMessage='Entity type'
            id='sputnik.NameAndOwnershipForm__adhRTA'
          />
        </span>
      }
      name='entityType'
      options={entityTypeOptions}
      placeholder={
        <FormattedMessage
          defaultMessage='Select'
          id='sputnik.EntityTypeCombobox__kQAf2d'
        />
      }
      readOnly={readOnly}
    />
  )
}

export default EntityTypeCombobox
